import axios from '@/resources/libs/axios'

export default {
    list() {
        return axios.get(`/vhe/auxiliaries/responsibles/list/all`)
    },
}